export default __webpack_public_path__ + "static/media/top_header.ccdd7245.less";